import { useState } from "react";
import { Box, FormLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import { FREYA_SCANNER_STORAGE_KEY, FREYA_SCANNERS } from "../../../common/constants";
import { useFreyaPrintSettingsScannerSelectorStyles } from "./styles";
import { FreyaScannersNames } from "common/enums";

interface FreyaPrintSettingsScannerSelectorProps {
  isScannerChecked?: boolean;
}

export const FreyaPrintSettingsScannerSelector = ({ isScannerChecked = false }: FreyaPrintSettingsScannerSelectorProps) => {
  const { t } = useTranslation("common");
  const styles = useFreyaPrintSettingsScannerSelectorStyles();
  const [selectedScannerId, setSelectedScannerId] = useState<FreyaScannersNames | null>(() => {
    if (isScannerChecked) {
      localStorage.setItem(FREYA_SCANNER_STORAGE_KEY, FreyaScannersNames.DENSOWAVE);
      return FreyaScannersNames.DENSOWAVE;
    }
    return null;
  });

  const handleScannerClick = (id: FreyaScannersNames) => {
    setSelectedScannerId(id);
    localStorage.setItem(FREYA_SCANNER_STORAGE_KEY, id);
  };
  return (
    <Box marginTop={3}>
      <FormLabel sx={styles.formLabel}>{t("settings.laserScannerType")}</FormLabel>
      <Box sx={styles.descriptionText}>{t("settings.selectTheTypeOfScanner")}</Box>
      <Grid container sx={styles.gridContainer}>
        {FREYA_SCANNERS.map(scanner => (
          <Box key={scanner.id} sx={styles.scannerItemContainer}>
            <Box onClick={() => handleScannerClick(scanner.id)} sx={styles.scannerBox(selectedScannerId === scanner.id)}>
              <Box component="img" src={scanner.image} alt="Scanner" sx={styles.scannerImage} />
            </Box>
            <Box sx={styles.scannerLabel(selectedScannerId === scanner.id)}>{t(`freya.scannerNames.${scanner.id}`)}</Box>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};
